// extracted by mini-css-extract-plugin
export default {"second_part":"second_second_part__9i5sU","second":"second_second__Ub4Wk","resend_code":"second_resend_code__e8fyW"};